<template>
    <span>
        <label v-if="labelText || labelIcon" :for="idTag" :class="customClasses">
            {{labelText}}
            <i v-if="labelIcon" :class="labelIcon" class="primary" />
        </label>
        <input type="file" style="display: none;" ref="fileImport" :id="idTag" @input="processSelection($event.target)" :accept="accept"/>
    </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        accept: {
            required: false,
            type: String,
        },
        onFileSelected: {
            required: false,
            type: Function,
        },
        idTag: {
            required: false,
            type: String,
        },
        labelText: {
            required: false,
            type: String,
        },
        labelIcon: {
            required: false,
            type: String,
        },
        customClasses: {
            required: false,
            type: String,
            default: 'input-type-file-to-el-button el-button el-button--primary text-caps',
        },
    },
    methods: {
        processSelection(target: HTMLInputElement): void {
            let file: File | null = null;
            const reader = new FileReader();
            const fileImport: any = this.$refs.fileImport;
            if (target.files && target.files.length > 0) {
                file = target.files[0];
                reader.onload = (e) => {
                    const buffer = reader.result;
                    if (buffer && file && this.$props.onFileSelected) {
                        this.$props.onFileSelected(buffer, file.name);
                    }
                };
                reader.readAsArrayBuffer(file);
            }

            // This is needed to make importing a file with the same name twice in a row.
            fileImport.value = '';
        },
    },
});
</script>
